import { circularProgressClasses } from '@mui/material'
import { SxProps } from '@mui/material'
import { SpinnerColors } from './Spinner.types'

interface SpinnerStyles {
  wrapper: SxProps
  back: SxProps
  front: SxProps
}

export const spinnerColors: SpinnerColors = {
  back: '#535862',
  front: '#FFFFFF',
}

export const spinnerStyles: SpinnerStyles = {
  wrapper: {
    position: 'relative',
  },
  back: {
    color: 'spinner.back',
    borderRadius: 10,
  },

  front: {
    color: 'spinner.front',
    animationDuration: '500ms',
    position: 'absolute',
    left: 0,
    [`& .${circularProgressClasses.circle}`]: {
      strokeLinecap: 'round',
    },
    [`& .${circularProgressClasses.circleDisableShrink}`]: {
      strokeDasharray: '30px, 100px',
    },
    borderRadius: 10,
  },
}
